export const parseApiResetPasswordError = (errorType?: string) => {
  if (errorType === 'INVALID_CODE') {
    return 'Invalid confirmation code.';
  }

  return "Can't reset password, please retry.";
};
